(function () {
    if (window.jwsdwSquarelovinSettings) {
        var widgetId = window.jwsdwSquarelovinSettings.squarelovinId;
        var widgetLang = window.jwsdwSquarelovinSettings.languageCode;
        var widgetType = window.jwsdwSquarelovinSettings.squarelovinType;
        var lastURL = '';
        var baseURL = location.href.substring(0, location.href.lastIndexOf('/'));
        var colors = window.jwsdwProductDetailSettings.data.allVariations.attributes.filter(function (color) {
            return color.id === 'color';
        });
        var productIds = colors && colors.length === 1 ? colors[0].vals.map(function(color) {
                return window.jwsdwProductDetailSettings.data.masterID + '_' + color.id;
            }) : [];

        // First run
        loadWidget();

        // Wait for Angular to render the colorSelection and set the event listeners
        var colorSelectionInterval = setInterval(function () {
            var colorSelection = document.querySelector('.jwsdw-pdp-colorSelection');
            if (colorSelection) {
                setEvents(colorSelection);
                clearInterval(colorSelectionInterval);
            }
        }, 100);
    }

    function loadWidget() {
        setTimeout(function () {
            var url = baseURL + '/' + location.href.substr(location.href.lastIndexOf('/') + 1);
            if (lastURL !== location.href) {
                var target = document.getElementById('squarelovin-slot');
                var js = document.getElementById('squarelovin-js');
                lastURL = location.href;

                // Cleanup the widget code and script
                if (target) {
                    target.innerHTML = '';
                }
                if (js) {
                    js.parentElement.removeChild(js);
                }

                // The placeholder script (used by Squarelovin to render the widget)
                if (target) {
                    var s1 = document.createElement('script');
                    s1.id = 'sqln-' + widgetId;
                    s1.type = 'text/javascript';
                    s1.datastream = widgetId;
                    target.appendChild(s1);
                }

                // The Squarelovin widget code
                var s = document.createElement('script');
                s.id = 'squarelovin-js';
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://squarelovin.com/squarelovin.js?stream=' + widgetId +
                    '&t=' + widgetType +
                    '&l=' + widgetLang +
                    '&pid=' + productIds.join(',') +
                    '&u=' + url;

                var sc = document.getElementsByTagName('script')[0];
                sc.parentNode.insertBefore(s, sc);
            }
        }, 300); // A little delay is added to wait for the URL to change
    }

    function setEvents(el) {
        el.addEventListener('mouseup', loadWidget);
        el.addEventListener('touchend', loadWidget);
    }
})();
